<birdz-modal>
  <div modal-title>{{ 'HELP_INDEX_1' | transloco }}</div>
  <div modal-body class="body">
    <p>{{ 'HELP_INDEX_2' | transloco }}{{ 'COLON' | transloco }}</p>
    <ul>
      <li>
        {{ 'HELP_INDEX_3' | transloco }}<br />
        <code>{{ 'HELP_INDEX_3B' | transloco }}</code>
      </li>
    </ul>
  </div>
</birdz-modal>
